// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__hbmqd","icon":"styles_icon__odzUU","content":"styles_content__JrIG-"};